function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { precision } from "./precision.js";
import SweepEvent from "./sweep-event.js";
export var RingOut = /*#__PURE__*/ function() {
    "use strict";
    function RingOut(events) {
        _class_call_check(this, RingOut);
        _define_property(this, "events", void 0);
        _define_property(this, "poly", void 0);
        _define_property(this, "_isExteriorRing", void 0);
        _define_property(this, "_enclosingRing", void 0);
        this.events = events;
        for(var i = 0, iMax = events.length; i < iMax; i++){
            events[i].segment.ringOut = this;
        }
        this.poly = null;
    }
    _create_class(RingOut, [
        {
            key: "getGeom",
            value: function getGeom() {
                // Remove superfluous points (ie extra points along a straight line),
                var prevPt = this.events[0].point;
                var points = [
                    prevPt
                ];
                for(var i = 1, iMax = this.events.length - 1; i < iMax; i++){
                    var pt = this.events[i].point;
                    var nextPt = this.events[i + 1].point;
                    if (precision.orient(pt, prevPt, nextPt) === 0) continue;
                    points.push(pt);
                    prevPt = pt;
                }
                // ring was all (within rounding error of angle calc) colinear points
                if (points.length === 1) return null;
                // check if the starting point is necessary
                var pt1 = points[0];
                var nextPt1 = points[1];
                if (precision.orient(pt1, prevPt, nextPt1) === 0) points.shift();
                points.push(points[0]);
                var step = this.isExteriorRing() ? 1 : -1;
                var iStart = this.isExteriorRing() ? 0 : points.length - 1;
                var iEnd = this.isExteriorRing() ? points.length : -1;
                var orderedPoints = [];
                for(var i1 = iStart; i1 != iEnd; i1 += step)orderedPoints.push([
                    points[i1].x.toNumber(),
                    points[i1].y.toNumber()
                ]);
                return orderedPoints;
            }
        },
        {
            key: "isExteriorRing",
            value: function isExteriorRing() {
                if (this._isExteriorRing === undefined) {
                    var enclosing = this.enclosingRing();
                    this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
                }
                return this._isExteriorRing;
            }
        },
        {
            key: "enclosingRing",
            value: function enclosingRing() {
                if (this._enclosingRing === undefined) {
                    this._enclosingRing = this._calcEnclosingRing();
                }
                return this._enclosingRing;
            }
        },
        {
            /* Returns the ring that encloses this one, if any */ key: "_calcEnclosingRing",
            value: function _calcEnclosingRing() {
                // start with the ealier sweep line event so that the prevSeg
                // chain doesn't lead us inside of a loop of ours
                var leftMostEvt = this.events[0];
                for(var i = 1, iMax = this.events.length; i < iMax; i++){
                    var evt = this.events[i];
                    if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
                }
                var prevSeg = leftMostEvt.segment.prevInResult();
                var prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
                while(true){
                    // no segment found, thus no ring can enclose us
                    if (!prevSeg) return null;
                    // no segments below prev segment found, thus the ring of the prev
                    // segment must loop back around and enclose us
                    if (!prevPrevSeg) return prevSeg.ringOut;
                    // if the two segments are of different rings, the ring of the prev
                    // segment must either loop around us or the ring of the prev prev
                    // seg, which would make us and the ring of the prev peers
                    if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
                        var _prevPrevSeg_ringOut, _prevSeg_ringOut;
                        if (((_prevPrevSeg_ringOut = prevPrevSeg.ringOut) === null || _prevPrevSeg_ringOut === void 0 ? void 0 : _prevPrevSeg_ringOut.enclosingRing()) !== prevSeg.ringOut) {
                            return prevSeg.ringOut;
                        } else return (_prevSeg_ringOut = prevSeg.ringOut) === null || _prevSeg_ringOut === void 0 ? void 0 : _prevSeg_ringOut.enclosingRing();
                    }
                    // two segments are from the same ring, so this was a penisula
                    // of that ring. iterate downward, keep searching
                    prevSeg = prevPrevSeg.prevInResult();
                    prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
                }
            }
        }
    ], [
        {
            key: "factory",
            value: /* Given the segments from the sweep line pass, compute & return a series
     * of closed rings from all the segments marked to be part of the result */ function factory(allSegments) {
                var ringsOut = [];
                for(var i = 0, iMax = allSegments.length; i < iMax; i++){
                    var segment = allSegments[i];
                    if (!segment.isInResult() || segment.ringOut) continue;
                    var prevEvent = null;
                    var event = segment.leftSE;
                    var nextEvent = segment.rightSE;
                    var events = [
                        event
                    ];
                    var startingPoint = event.point;
                    var intersectionLEs = [];
                    /* Walk the chain of linked events to form a closed ring */ while(true){
                        prevEvent = event;
                        event = nextEvent;
                        events.push(event);
                        /* Is the ring complete? */ if (event.point === startingPoint) break;
                        while(true){
                            var availableLEs = event.getAvailableLinkedEvents();
                            /* Did we hit a dead end? This shouldn't happen. Indicates some earlier
                     * part of the algorithm malfunctioned... please file a bug report. */ if (availableLEs.length === 0) {
                                var firstPt = events[0].point;
                                var lastPt = events[events.length - 1].point;
                                throw new Error("Unable to complete output ring starting at [".concat(firstPt.x, ",") + " ".concat(firstPt.y, "]. Last matching segment found ends at") + " [".concat(lastPt.x, ", ").concat(lastPt.y, "]."));
                            }
                            /* Only one way to go, so cotinue on the path */ if (availableLEs.length === 1) {
                                nextEvent = availableLEs[0].otherSE;
                                break;
                            }
                            /* We must have an intersection. Check for a completed loop */ var indexLE = null;
                            for(var j = 0, jMax = intersectionLEs.length; j < jMax; j++){
                                if (intersectionLEs[j].point === event.point) {
                                    indexLE = j;
                                    break;
                                }
                            }
                            /* Found a completed loop. Cut that off and make a ring */ if (indexLE !== null) {
                                var intersectionLE = intersectionLEs.splice(indexLE)[0];
                                var ringEvents = events.splice(intersectionLE.index);
                                ringEvents.unshift(ringEvents[0].otherSE);
                                ringsOut.push(new RingOut(ringEvents.reverse()));
                                continue;
                            }
                            /* register the intersection */ intersectionLEs.push({
                                index: events.length,
                                point: event.point
                            });
                            /* Choose the left-most option to continue the walk */ var comparator = event.getLeftmostComparator(prevEvent);
                            nextEvent = availableLEs.sort(comparator)[0].otherSE;
                            break;
                        }
                    }
                    ringsOut.push(new RingOut(events));
                }
                return ringsOut;
            }
        }
    ]);
    return RingOut;
}();
export var PolyOut = /*#__PURE__*/ function() {
    "use strict";
    function PolyOut(exteriorRing) {
        _class_call_check(this, PolyOut);
        _define_property(this, "exteriorRing", void 0);
        _define_property(this, "interiorRings", void 0);
        this.exteriorRing = exteriorRing;
        exteriorRing.poly = this;
        this.interiorRings = [];
    }
    _create_class(PolyOut, [
        {
            key: "addInterior",
            value: function addInterior(ring) {
                this.interiorRings.push(ring);
                ring.poly = this;
            }
        },
        {
            key: "getGeom",
            value: function getGeom() {
                var geom0 = this.exteriorRing.getGeom();
                // exterior ring was all (within rounding error of angle calc) colinear points
                if (geom0 === null) return null;
                var geom = [
                    geom0
                ];
                for(var i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                    var ringGeom = this.interiorRings[i].getGeom();
                    // interior ring was all (within rounding error of angle calc) colinear points
                    if (ringGeom === null) continue;
                    geom.push(ringGeom);
                }
                return geom;
            }
        }
    ]);
    return PolyOut;
}();
export var MultiPolyOut = /*#__PURE__*/ function() {
    "use strict";
    function MultiPolyOut(rings) {
        _class_call_check(this, MultiPolyOut);
        _define_property(this, "rings", void 0);
        _define_property(this, "polys", void 0);
        this.rings = rings;
        this.polys = this._composePolys(rings);
    }
    _create_class(MultiPolyOut, [
        {
            key: "getGeom",
            value: function getGeom() {
                var geom = [];
                for(var i = 0, iMax = this.polys.length; i < iMax; i++){
                    var polyGeom = this.polys[i].getGeom();
                    // exterior ring was all (within rounding error of angle calc) colinear points
                    if (polyGeom === null) continue;
                    geom.push(polyGeom);
                }
                return geom;
            }
        },
        {
            key: "_composePolys",
            value: function _composePolys(rings) {
                var polys = [];
                for(var i = 0, iMax = rings.length; i < iMax; i++){
                    var ring = rings[i];
                    if (ring.poly) continue;
                    if (ring.isExteriorRing()) polys.push(new PolyOut(ring));
                    else {
                        var _enclosingRing_poly;
                        var enclosingRing = ring.enclosingRing();
                        if (!(enclosingRing === null || enclosingRing === void 0 ? void 0 : enclosingRing.poly)) polys.push(new PolyOut(enclosingRing));
                        enclosingRing === null || enclosingRing === void 0 ? void 0 : (_enclosingRing_poly = enclosingRing.poly) === null || _enclosingRing_poly === void 0 ? void 0 : _enclosingRing_poly.addInterior(ring);
                    }
                }
                return polys;
            }
        }
    ]);
    return MultiPolyOut;
}();
